import axios from 'axios'

const StoreFinderKey = process.env.STORE_FINDER_API_KEY
const StoreFinderBaseUrl = process.env.STORE_FINDER_BASE_URL
let dataLayer

if (typeof window !== `undefined`) {
  dataLayer = window.dataLayer
}

export const fetchLocations = searchTerm => {
  let query = `${encodeURIComponent(searchTerm)}`

  const postcodesPromise = axios.get(
    `https://postcodes.io/postcodes/${query}/autocomplete`
  )
  const placesPromise = axios.get(`https://api.postcodes.io/places?q=${query}`)

  Promise.all([postcodesPromise, placesPromise])
    .then(([postodes, places]) => {
      if (
        (postodes?.data?.result?.length === 0 ||
          places?.data?.result?.length === 0) &&
        searchTerm &&
        searchTerm.length > 2
      ) {
        if (dataLayer && dataLayer.push) {
          dataLayer.push({ event: 'nullSearch', searchTerm: searchTerm })
        }
      }
    })
    .catch(e => {
      console.log('Error fetching places data ', e?.message)
    })

  return { postcodesPromise, placesPromise }
}

export const getStoresFromPostcode = async postcode => {
  const geo = await axios
    .get(`https://postcodes.io/postcodes/${postcode}`)
    .catch(e => {
      throw e
    })

  const { longitude, latitude } = geo?.data?.result || {}
  const storeResults = await axios
    .get(
      `${StoreFinderBaseUrl}?apikey=${StoreFinderKey}&distance=50000&lat=${latitude}&lon=${longitude}&limit=10&storeformat=supermarket`
    )
    .catch(e => {
      throw e
    })
  return { stores: storeResults.data?.stores, longitude, latitude }
}

export const getStoresFromLocation = async (longitude, latitude) => {
  const storeResults = await axios
    .get(
      `${StoreFinderBaseUrl}?apikey=${StoreFinderKey}&distance=50000&lat=${latitude}&lon=${longitude}&limit=10&storeformat=supermarket`
    )
    .catch(e => {
      throw e
    })
  return storeResults.data
}

export const getLocationFromPostcode = async postcodeEntered => {
  const geo = await axios
    .get(`https://postcodes.io/postcodes/${postcodeEntered}`)
    .catch(e => {
      throw e
    })

  const { longitude, latitude, postcode } = geo?.data?.result || {}

  return { longitude, latitude, postcode }
}

export const getLocationFromPlace = async place => {
  const response = await axios
    .get(`https://api.postcodes.io/places?q=${place}`)
    .catch(e => {
      throw e
    })

  const { longitude, latitude, name_1, county_unitary, outcode } =
    response?.data?.result?.[0] || {}

  return {
    longitude,
    latitude,
    placeName: `${name_1}, ${
      county_unitary ? `${county_unitary}, ` : ''
    } ${outcode}`,
  }
}

export const getPostcodeFromPartialPostcode = async partialPostcode => {
  const response = await axios
    .get(`https://postcodes.io/postcodes/${partialPostcode}/autocomplete`)
    .catch(e => {
      throw e
    })

  const postcode = response?.data?.result?.[0] || ''

  return {
    postcode,
  }
}

export const getStoreSpecialTimes = async storeId => {
  const storeResults = await axios
    .get(
      `${StoreFinderBaseUrl}/${storeId}/specialopeningtimes?apikey=${StoreFinderKey}`
    )
    .catch(e => {
      throw e
    })

  return storeResults.data
}
export const getPlaceFromLatLong = async (lat, lng) => {
  const response = await fetch(
    `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`
  ).catch(e => {
    throw e
  })
  if (!response?.ok) {
    throw new Error('Failed to fetch location data')
  }
  return response.json()
}
export const getPlaceFromLatLongFallback = async (lat, lng) => {
  const response = await fetch(
    `https://geocode.maps.co/reverse?lat=${lat}&lon=${lng}`
  ).catch(e => {
    // throw e
  })
  if (!response?.ok) {
    return null
  }
  return response.json()
}
